export default function offerVibrantColors(tw, offer, defaultVibrantColors=[tw`text-blue`.color, tw`text-blue-dark`.color]) {
  if (!offer?.vibrant_colors) return defaultVibrantColors;

  const offerVibrantColors = offer.vibrant_colors.split(',');
  if (offerVibrantColors.length === 2) return offerVibrantColors;
  if (offerVibrantColors.length === 1) return [offerVibrantColors[0], defaultVibrantColors[1]];
  else return defaultVibrantColors;
}
